import React, { useState } from "react";
import {
  Grid,
  Typography,
  Tabs,
  Tab,
  Box,
} from "@mui/material";
import RoadkillCitiesConfig from "./RoadkillCitiesConfig";
import RoadkillCharactersConfig from "./RoadkillCharactersConfig";

export default function RoadkillConfig({
  gameConfig,
  setGameConfig,
  loading = false,
  gameProvider,
}) {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Typography variant="h6" gutterBottom>
          Roadkill Configuration
        </Typography>
        <Box sx={{ mb: 1 }}>
          <Tabs
            value={activeTab}
            onChange={handleTabChange}
            aria-label="roadkill tabs"
          >
            <Tab label="Cities" />
            <Tab label="Characters" />
          </Tabs>
        </Box>

        {activeTab === 0 && (
          <RoadkillCitiesConfig
            gameConfig={gameConfig}
            setGameConfig={setGameConfig}
            loading={loading}
          />
        )}
        {activeTab === 1 && (
          <RoadkillCharactersConfig
            gameConfig={gameConfig}
            setGameConfig={setGameConfig}
            loading={loading}
          />
        )}
      </Grid>
    </Grid>
  );
}
